import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/voiceagent-app/RestroAgent/src/app/(landing)/LandingShell.tsx");
